import Sdk from 'api.digitalpages.module.sdk.api';
import {format} from "date-fns";
import jwtDecode from "jwt-decode";
import UserEvent from "../events/user";
import axios from 'axios';
import Offliner from "../hooks/offliner";
import TranslationEN from '../translations/en.json';
import TranslationPTBR from '../translations/pt-br.json';

export function Flows() {
  var defaultConfigs = {};

  async function configs() {
    if (Sdk.Api.authorization.activeProject && Sdk.authorization.projects.length > 0) {

    var connector = Sdk.authorization.activeProject.connectors.filter(item => item.type === "Customization_1");
    // var connectorUid = Sdk.Api.authorization.activeProject.connectors.filter(connector => connector.type === "Customization_1")[0].uid;

    if (connector.length > 0) {
      var connectorUid = connector[0].uid;
      const response = await Sdk.Api.dynamic.bridge(`auth/v1.1/connector/uid/${connectorUid}`, null, 'GET');

      defaultConfigs = {
        "headerBackground": "#fff",
        "headerDropdownBackground": "#fff",
        "logotype": "",
        "sidebarActiveButtonBackgroundColor": "#016099",
        "sidebarButtonBackgroundColor": "#fff",
        "sidebarPosition": "esquerda",
        "sidebarLabelColor": "",
        "sidebarActiveLabelColor": ""
      };

      response["configuration"]["configs"].map(
        async ({
          uid,
          value
        }) => {
          switch (uid) {
            //TODO: DEPRECATED
            case 'headerBackground':
              defaultConfigs.headerBackground = value;
              break;
            //TODO: DEPRECATED
            case 'sidebarActiveButtonBackgroundColor':
              defaultConfigs.sidebarActiveButtonBackgroundColor = value;
              break;
            //TODO: DEPRECATED
            case 'sidebarButtonBackgroundColor':
              defaultConfigs.sidebarButtonBackgroundColor = value;
              break;
            //TODO: DEPRECATED
            case 'sidebarPosition':
              defaultConfigs.sidebarPosition = value;
              break
            //TODO: DEPRECATED
            case 'headerDropdownBackground':
              defaultConfigs.headerDropdownBackground = value;
              break
            //TODO: DEPRECATED
            case 'headerLogotype':
              defaultConfigs.headerLogotype = value;
              break;
            //TODO: DEPRECATED
            case 'sidebarLabelColor':
              defaultConfigs.sidebarLabelColor = value;
              break;
            //TODO: DEPRECATED
            case 'sidebarActiveLabelColor':
              defaultConfigs.sidebarActiveLabelColor = value;
              break;
            //TODO: DEPRECATED
            case 'headerFirstLabelColor':
              defaultConfigs.headerFirstLabelColor = value;
              break;
            //TODO: DEPRECATED
            case 'headerSecondLabelColor':
              defaultConfigs.headerSecondLabelColor = value;
              break;
            case 'header':
              try {
                JSON.parse(value).map(({uid, value}) => {
                  switch (uid) {
                    case 'background':
                      defaultConfigs.headerBackground = value;
                      break
                    case 'dropdown_background':
                      defaultConfigs.headerDropdownBackground = value;
                      break
                    case 'logotype':
                      defaultConfigs.headerLogotype = value;
                      break
                    case 'first_label_color':
                      defaultConfigs.headerFirstLabelColor = value;
                      break
                    case 'second_label_color':
                      defaultConfigs.headerSecondLabelColor = value;
                      break
                  }
                })
              } catch (e) {
                // console.log('error', e);
              }
              break;
            case 'sidebar':
              try {
                JSON.parse(value).map(({uid, value}) => {
                  switch (uid) {
                    case 'active_button_background_color':
                      defaultConfigs.sidebarActiveButtonBackgroundColor = value;
                      break
                    case 'button_background_color':
                      defaultConfigs.sidebarButtonBackgroundColor = value;
                      break
                    case 'active_label_color':
                      defaultConfigs.sidebarActiveLabelColor = value;
                      break
                    case 'label_color':
                      defaultConfigs.sidebarLabelColor = value;
                      break
                  }
                })
              } catch (e) {
                // console.log('error', e);
              }
              break;
            default:

          }
        })
      }
    }

    return defaultConfigs;
  }

  return {
    template_configs: async function () {
      const getConfigs = await configs();

      return getConfigs;
    },

    "get_reviewer_submissions_waiting": async function(params, bridgeWrapper) {
      var response = await bridgeWrapper(`cms/v1.0/review/tasks/history/reviewer?status=WaitingReviewer`);
      response = response.result;

      for (var i = 0; i < response.length; i++) {
        const task = response[i];
        const targetType = task.target_type.toLowerCase();
        const details = await bridgeWrapper(`cms/v1.0/learning/review/task/uid/${task.uid}/interaction/details`);

        task.details = details;
      };

      if (response[0]) {
        return {
          "uid": response[0].uid,
          "route": `/submissoes/${response[0].flow.uid}/${response[0].target_uid}`,
          "items": [
            {
              "title": "Aluno",
              // "subtitle": response[0].user.detail.name
              "subtitle": response[0].target_user_uid
            },
            {
              "title": "Curso",
              "subtitle": response[0].details.course.title
            },
            {
              "title": "Projeto",
              "subtitle": response[0].flow.title
            }
          ]
        }
      } else {
        return {
          "empty": true
        }
      }
    },
    "get_reviewer_submissions_pending": async function(params, bridgeWrapper) {
      const response = await bridgeWrapper(`cms/v1.0/review/tasks/pending/reviewer/priority`, true);

      for (var i = 0; i < response.length; i++) {
        // const subResponse = await bridgeWrapper(`auth/v1.0/user/uid/${response[i].target_user_uid}`);
        // response[i].user = subResponse;

        const details = await bridgeWrapper(`cms/v1.0/learning/review/task/uid/${response[i].uid}/interaction/details`);
        response[i].details = details;
      };

      if (response[0]) {
        return {
          "uid": response[0].uid,
          "route": `/submissoes/${response[0].flow.uid}/${response[0].target_uid}`,
          "items": [
            {
              "title": "Aluno",
              // "subtitle": response[0].user.detail.name
              "subtitle": response[0].target_user_uid
            },
            {
              "title": "Curso",
              "subtitle": response[0].details.course.title
            },
            {
              "title": "Projeto",
              "subtitle": response[0].flow.title
            }
          ]
        }
      } else {
        return {
          "empty": true
        }
      }
    },
    "get_reviewer_submissions_history": async function(params, bridgeWrapper) {
      const response = await bridgeWrapper(`cms/v1.0/review/tasks/history/reviewer`);
      var submissions = response.result;

      for (var i = 0; i < submissions.length; i++) {
        // const subResponse = await bridgeWrapper(`auth/v1.0/user/uid/${submissions[i].target_user_uid}`);
        // submissions[i].user = subResponse

        const task = submissions[i];
        const details = await bridgeWrapper(`cms/v1.0/learning/review/task/uid/${task.uid}/interaction/details`);
        task.details = details;
      };

      submissions = submissions.sort((a, b) => (a.review_request_at > b.review_request_at) ? -1 : 1);

      return response;
    },
    "get_reviewer_student_submission_review": async function(params, bridgeWrapper) {
      const response = await bridgeWrapper(`cms/v1.0/review/flow/uid/${params.flowUid}/target/uid/${params.targetUid}/history?author_uid=${params.userUid}&status=failed&status=passed&status=waitingreviewer`);
      const user = await bridgeWrapper(`auth/v1.0/user/uid/${response[0].target_user_uid}`);
      const details = await bridgeWrapper(`cms/v1.0/learning/review/task/uid/${response[0].uid}/interaction/details`);

      var list = response.sort((a, b) => (a.review_request_at > b.review_request_at) ? -1 : 1);

      for (let i = 0; i < list.length; i++) {
        const contents = await bridgeWrapper(`cms/v1.0/review/task/uid/${list[i].uid}/contents`);
        const manifest = await bridgeWrapper(`storage/v1.0/content/path/manifest.json?uid=${contents.target_content_uid}`);
        list[i].user = user;
        list[i].manifest = manifest;
        list[i].file = `${Sdk.domain}/storage/${Sdk.Api.version}/content?uid=${contents.target_content_uid}&file_path=${manifest.sources[0].uri}&project_key=${Sdk.Api.projectKey}&access_token=${Sdk.Api.authorization_token || Sdk.authorization.credential.accessToken}&api_env=${Sdk.Api.enviroment}`
      }

      // list[0].user = user;
      list[0].details = details;
      list[0].course_title = details.course.title;
      list[0].project_title = details.node.data.title;

      return list;
    },
    "get_reviewer_student_submission_content": async function(params, bridgeWrapper) {
      const response = await bridgeWrapper(`cms/v1.0/review/task/uid/${params.uid}/contents`);
      const manifest = await bridgeWrapper(`storage/v1.0/content/path/manifest.json?uid=${response.target_content_uid}`);
      const reviewer_manifest = await bridgeWrapper(`storage/v1.0/content/path/manifest.json?uid=${response.review_content_uid}`);
      const details = await bridgeWrapper(`cms/v1.0/learning/review/task/uid/${params.uid}/interaction/details`);

      var sources = manifest.sources;
      for (var i = 0; i < sources.length; i++) {
        sources[i].language = sources[i].mime_type !== null ? sources[i].mime_type.split("/")[1] : "auto";
        sources[i].name = sources[i].uri;
        sources[i].url = `${Sdk.domain}/storage/${Sdk.Api.version}/content?uid=${response.target_content_uid}&file_path=${sources[i].uri}&project_key=${Sdk.Api.projectKey}&access_token=${Sdk.authorization.credential.accessToken}&api_env=${Sdk.Api.enviroment}`
        // await fetch(sources[i].url).then(resp => resp.text()).then(content => sources[i].value = content)
      };

      const node = details.node;
      const activity = node.activities.find(activity => activity.uid === details.activity_uid);
      const rubrics = await bridgeWrapper(`cms/v1.0/review/flow/uid/${activity.review_flows[0]}`)

      response.sources = sources;
      response.details = details;
      response.rubrics = rubrics;
      response.reviewer_manifest = reviewer_manifest;
      response.back_route = `/submissoes/flow/${response.flow.uid}/target/${response.target_uid}/user/${response.target_user_uid}`;

      return response;
    },
    "get_student_available_reviews": async function(params, bridgeWrapper) {
      //TODO
      const response = await bridgeWrapper(`cms/v1.0/review/tasks/status/failed?filter_state=active`);
      const items = response.result;
      var temp = [];

      for (var i = 0; i < items.length; i++) {
        const details = await bridgeWrapper(`cms/v1.0/learning/review/task/uid/${items[i].uid}/interaction/details`);

        temp.push({
          "id": items[i].target_uid,
          "course_name": `<b>${details.course.title}</b>`,
          "project_name": `Projeto: <b>${items[i].flow.title}</b>`,
          "instruction_label": "Ajuste seu projeto <b>e reenvie para a revisão</b>",
          "link": `/player/curso/${details.course.uid}/registro/${details.register.uid}/atividade/${details.activity.uid}`
        });
      }

      return temp;
    },
    get_courses_by_category: async function (params, bridgeWrapper) {
      var entitiesModel = [];
      var entities = [];
      // console.log("///////cursos: get_courses_by_category")
      const coursesRegister = await bridgeWrapper(`cms/v1.0/learning/courses/register`);
      const coursesRegistered = await bridgeWrapper(`cms/v1.1/learning/courses?page_size=500`);
      // console.log("///////cursos: get_courses_by_category - recebido")

      var obj = {};

      var tags = [
        {
          name: "Certified course",
          color: "#0186f8",
          backgroundColor: "#B7DEFF",
          icon: "<svg width='21' height='19' viewBox='0 0 21 19' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 6.996C16.7702 6.99562 17.5242 7.21761 18.1713 7.63532C18.8184 8.05302 19.3311 8.64867 19.6479 9.35071C19.9648 10.0528 20.0721 10.8313 19.9572 11.5929C19.8423 12.3545 19.5099 13.0667 19 13.644V18.244C19.0003 18.3724 18.9675 18.4987 18.905 18.6109C18.8424 18.723 18.7521 18.8172 18.6427 18.8844C18.5334 18.9517 18.4085 18.9897 18.2802 18.9949C18.1519 19.0001 18.0245 18.9722 17.91 18.914L17.82 18.859L16 17.587L14.18 18.859C14.0749 18.9324 13.9527 18.9776 13.8252 18.9904C13.6976 19.0031 13.5689 18.9829 13.4514 18.9318C13.3338 18.8806 13.2313 18.8002 13.1537 18.6982C13.0761 18.5962 13.0259 18.4759 13.008 18.349L13.001 18.244V13.642C12.4918 13.0647 12.16 12.3528 12.0454 11.5916C11.9308 10.8305 12.0382 10.0524 12.3548 9.35076C12.6714 8.64913 13.1837 8.05376 13.8303 7.63608C14.4769 7.2184 15.2302 6.99615 16 6.996ZM17.5 14.706C17.0234 14.8987 16.5141 14.9975 16 14.997C15.4859 14.9975 14.9766 14.8987 14.5 14.706V16.805L15.571 16.058C15.6806 15.9812 15.8089 15.9351 15.9423 15.9245C16.0758 15.914 16.2096 15.9393 16.33 15.998L16.43 16.058L17.5 16.805V14.706ZM17.25 3.38855e-09C17.9503 -3.47392e-05 18.6242 0.267092 19.1343 0.746893C19.6444 1.22669 19.9522 1.88302 19.995 2.582L20 2.75L20.001 7.996C19.5955 7.45609 19.0853 7.00342 18.501 6.665L18.5 2.75C18.5001 2.44054 18.3855 2.14203 18.1782 1.91223C17.971 1.68244 17.6858 1.53769 17.378 1.506L17.25 1.5H2.75C2.44054 1.49986 2.14203 1.61451 1.91223 1.82177C1.68244 2.02903 1.53769 2.31417 1.506 2.622L1.5 2.75V12.25C1.5 12.897 1.992 13.43 2.622 13.493L2.75 13.5L11.672 13.501L11.795 13.704L11.929 13.9L12 13.994L11.999 15H2.75C2.04955 15 1.37549 14.7328 0.865376 14.2527C0.35526 13.7727 0.0475365 13.1162 0.00500012 12.417L3.38855e-09 12.25V2.75C-3.47392e-05 2.04971 0.267092 1.37579 0.746893 0.865703C1.22669 0.355612 1.88302 0.0477813 2.582 0.00500012L2.75 3.38855e-09H17.25ZM16 8.496C15.3368 8.496 14.7008 8.75945 14.2319 9.22838C13.7629 9.69732 13.4995 10.3333 13.4995 10.9965C13.4995 11.6597 13.7629 12.2957 14.2319 12.7646C14.7008 13.2336 15.3368 13.497 16 13.497C16.6632 13.497 17.2992 13.2336 17.7681 12.7646C18.2371 12.2957 18.5005 11.6597 18.5005 10.9965C18.5005 10.3333 18.2371 9.69732 17.7681 9.22838C17.2992 8.75945 16.6632 8.496 16 8.496ZM9.25 9.496C9.44002 9.49606 9.62294 9.56824 9.76179 9.69797C9.90064 9.8277 9.98507 10.0053 9.99803 10.1949C10.011 10.3845 9.95148 10.5719 9.83157 10.7193C9.71165 10.8667 9.54025 10.9631 9.352 10.989L9.25 10.996H4.75C4.55998 10.9959 4.37706 10.9238 4.23821 10.794C4.09936 10.6643 4.01493 10.4867 4.00197 10.2971C3.98902 10.1075 4.04852 9.92011 4.16843 9.7727C4.28835 9.62529 4.45975 9.5289 4.648 9.503L4.75 9.496H9.25ZM15.25 3.996C15.44 3.99606 15.6229 4.06824 15.7618 4.19797C15.9006 4.3277 15.9851 4.5053 15.998 4.69488C16.011 4.88446 15.9515 5.07189 15.8316 5.2193C15.7117 5.36671 15.5402 5.4631 15.352 5.489L15.25 5.496H4.75C4.55998 5.49594 4.37706 5.42376 4.23821 5.29403C4.09936 5.1643 4.01493 4.9867 4.00197 4.79712C3.98902 4.60754 4.04852 4.42011 4.16843 4.2727C4.28835 4.12529 4.45975 4.0289 4.648 4.003L4.75 3.996H15.25Z' fill='#8E8D8C'></path></svg>",
        },
      ];

      var myCourses = coursesRegistered.result;
      for (var i = 0; i < myCourses.length; i++) {
        var courseEntities = myCourses[i].course.entities;
        if (courseEntities) {
          for (var j = 0; j < courseEntities.length; j++) {
            entities.push(courseEntities[j]);
          }
        }
      }

      var courses = coursesRegister.result;
      for (var i = 0; i < courses.length; i++) {
        var courseEntities = courses[i].entities;
        if (courseEntities) {
          for (var j = 0; j < courseEntities.length; j++) {
            entities.push(courseEntities[j]);
          }
        }
      }

      entities = entities.filter((v, i, a) => a.indexOf(v) === i);
      for (var i = 0; i < entities.length; i++) {
        await bridgeWrapper(`auth/v1.0/entity/uid/${entities[i]}`).then(
          function (tempEntity) {
            entitiesModel.push({
              uid: tempEntity.uid,
              title: tempEntity.data.name,
              blocked: false,
              items: [],
            });
          },
          function () {
            return;
          }
        );
      }

      for (var i = 0; i < entitiesModel.length; i++) {
        for (var j = 0; j < courses.length; j++) {
          var courseEntities = courses[j].entities;
          for (var k = 0; k < courseEntities.length; k++) {
            if (entitiesModel[i].uid === courseEntities[k]) {
              entitiesModel[i].items.push({
                uid: courses[j].uid,
                title: courses[j].title,
                description: courses[j].description,
                cover: courses[j].thumb_url,
                blocked: false,
                progress: 0,
                registered: false,
                tags: tags,
                route: `/course/:contentUid/register/:registerUid`,
              });
            }
          }
        }

        for (var j = 0; j < myCourses.length; j++) {
          var courseEntities = myCourses[j].course.entities;
          for (var k = 0; k < courseEntities.length; k++) {
            if (entitiesModel[i].uid === courseEntities[k]) {
              entitiesModel[i].items.push({
                uid: myCourses[j].course.uid,
                title: myCourses[j].course.title,
                description: myCourses[j].course.description,
                cover: myCourses[j].course.thumb_url,
                blocked: false,
                progress: parseInt(
                  ((myCourses[j].activities.total_status_completed +
                    myCourses[j].activities.total_status_passed) /
                    myCourses[j].activities.total_activities) *
                    100
                ),
                registered: true,
                tags: tags,
                route: `/course/${myCourses[j].course.uid}/register/${myCourses[j].register.uid}`,
              });
            }
          }
        }
      }

      obj.categories = entitiesModel;

      return obj;
    },
    get_my_courses_by_category: async function (params, bridgeWrapper) {
      var entitiesModel = [];
      var entities = [];
      // console.log("///////cursos: get_my_courses_by_category")
      const coursesRegistered = await bridgeWrapper(`cms/v1.1/learning/courses?page_size=500`);
      // console.log("///////cursos: get_my_courses_by_category - Recebido")

      var obj = {};

      var tags = [
        {
          name: "Certified course",
          color: "#0186f8",
          backgroundColor: "#B7DEFF",
          icon: "<svg width='21' height='19' viewBox='0 0 21 19' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 6.996C16.7702 6.99562 17.5242 7.21761 18.1713 7.63532C18.8184 8.05302 19.3311 8.64867 19.6479 9.35071C19.9648 10.0528 20.0721 10.8313 19.9572 11.5929C19.8423 12.3545 19.5099 13.0667 19 13.644V18.244C19.0003 18.3724 18.9675 18.4987 18.905 18.6109C18.8424 18.723 18.7521 18.8172 18.6427 18.8844C18.5334 18.9517 18.4085 18.9897 18.2802 18.9949C18.1519 19.0001 18.0245 18.9722 17.91 18.914L17.82 18.859L16 17.587L14.18 18.859C14.0749 18.9324 13.9527 18.9776 13.8252 18.9904C13.6976 19.0031 13.5689 18.9829 13.4514 18.9318C13.3338 18.8806 13.2313 18.8002 13.1537 18.6982C13.0761 18.5962 13.0259 18.4759 13.008 18.349L13.001 18.244V13.642C12.4918 13.0647 12.16 12.3528 12.0454 11.5916C11.9308 10.8305 12.0382 10.0524 12.3548 9.35076C12.6714 8.64913 13.1837 8.05376 13.8303 7.63608C14.4769 7.2184 15.2302 6.99615 16 6.996ZM17.5 14.706C17.0234 14.8987 16.5141 14.9975 16 14.997C15.4859 14.9975 14.9766 14.8987 14.5 14.706V16.805L15.571 16.058C15.6806 15.9812 15.8089 15.9351 15.9423 15.9245C16.0758 15.914 16.2096 15.9393 16.33 15.998L16.43 16.058L17.5 16.805V14.706ZM17.25 3.38855e-09C17.9503 -3.47392e-05 18.6242 0.267092 19.1343 0.746893C19.6444 1.22669 19.9522 1.88302 19.995 2.582L20 2.75L20.001 7.996C19.5955 7.45609 19.0853 7.00342 18.501 6.665L18.5 2.75C18.5001 2.44054 18.3855 2.14203 18.1782 1.91223C17.971 1.68244 17.6858 1.53769 17.378 1.506L17.25 1.5H2.75C2.44054 1.49986 2.14203 1.61451 1.91223 1.82177C1.68244 2.02903 1.53769 2.31417 1.506 2.622L1.5 2.75V12.25C1.5 12.897 1.992 13.43 2.622 13.493L2.75 13.5L11.672 13.501L11.795 13.704L11.929 13.9L12 13.994L11.999 15H2.75C2.04955 15 1.37549 14.7328 0.865376 14.2527C0.35526 13.7727 0.0475365 13.1162 0.00500012 12.417L3.38855e-09 12.25V2.75C-3.47392e-05 2.04971 0.267092 1.37579 0.746893 0.865703C1.22669 0.355612 1.88302 0.0477813 2.582 0.00500012L2.75 3.38855e-09H17.25ZM16 8.496C15.3368 8.496 14.7008 8.75945 14.2319 9.22838C13.7629 9.69732 13.4995 10.3333 13.4995 10.9965C13.4995 11.6597 13.7629 12.2957 14.2319 12.7646C14.7008 13.2336 15.3368 13.497 16 13.497C16.6632 13.497 17.2992 13.2336 17.7681 12.7646C18.2371 12.2957 18.5005 11.6597 18.5005 10.9965C18.5005 10.3333 18.2371 9.69732 17.7681 9.22838C17.2992 8.75945 16.6632 8.496 16 8.496ZM9.25 9.496C9.44002 9.49606 9.62294 9.56824 9.76179 9.69797C9.90064 9.8277 9.98507 10.0053 9.99803 10.1949C10.011 10.3845 9.95148 10.5719 9.83157 10.7193C9.71165 10.8667 9.54025 10.9631 9.352 10.989L9.25 10.996H4.75C4.55998 10.9959 4.37706 10.9238 4.23821 10.794C4.09936 10.6643 4.01493 10.4867 4.00197 10.2971C3.98902 10.1075 4.04852 9.92011 4.16843 9.7727C4.28835 9.62529 4.45975 9.5289 4.648 9.503L4.75 9.496H9.25ZM15.25 3.996C15.44 3.99606 15.6229 4.06824 15.7618 4.19797C15.9006 4.3277 15.9851 4.5053 15.998 4.69488C16.011 4.88446 15.9515 5.07189 15.8316 5.2193C15.7117 5.36671 15.5402 5.4631 15.352 5.489L15.25 5.496H4.75C4.55998 5.49594 4.37706 5.42376 4.23821 5.29403C4.09936 5.1643 4.01493 4.9867 4.00197 4.79712C3.98902 4.60754 4.04852 4.42011 4.16843 4.2727C4.28835 4.12529 4.45975 4.0289 4.648 4.003L4.75 3.996H15.25Z' fill='#8E8D8C'></path></svg>",
        },
      ];

      var myCourses = coursesRegistered.result;
      for (var i = 0; i < myCourses.length; i++) {
        var courseEntities = myCourses[i].course.entities;
        if (courseEntities) {
          for (var j = 0; j < courseEntities.length; j++) {
            entities.push(courseEntities[j]);
          }
        }
      }

      entities = entities.filter((v, i, a) => a.indexOf(v) === i);

      for (var i = 0; i < entities.length; i++) {
        await bridgeWrapper(`auth/v1.0/entity/uid/${entities[i]}`).then(
          function (tempEntity) {
            entitiesModel.push({
              uid: tempEntity.uid,
              title: tempEntity.data.name,
              blocked: false,
              items: [],
            });
          },
          function () {
            return;
          }
        );
      }

      for (var i = 0; i < entitiesModel.length; i++) {
        for (var j = 0; j < myCourses.length; j++) {
          var courseEntities = myCourses[j].course.entities;
          for (var k = 0; k < courseEntities.length; k++) {
            if (entitiesModel[i].uid === courseEntities[k]) {
              entitiesModel[i].items.push({
                uid: myCourses[j].course.uid,
                title: myCourses[j].course.title,
                description: myCourses[j].course.description,
                cover: myCourses[j].course.thumb_url,
                blocked: false,
                progress: parseInt(
                  (myCourses[j].activities.total_status_completed /
                    myCourses[j].activities.total_activities) *
                    100
                ),
                registered: true,
                tags: tags,
                route: `/course/${myCourses[j].course.uid}/register/${myCourses[j].register.uid}`,
              });
            }
          }
        }
      }

      obj.categories = entitiesModel;

      return obj;
    },
    "get_course_details": async function(params, bridgeWrapper) {
      const response = await bridgeWrapper(`cms/v1.0/learning/course/uid/${params.uid}`);
      const tree = await bridgeWrapper(`cms/v1.0/learning/course/uid/${params.uid}/nodes/tree`);
      // alert(params.registerUid)

      var obj = {
        "route": `/course/${params.uid}/register/${params.registerUid}`,
        "texts": [{
          "title": "About this course",
          "content": response.description,
        },
        {
          "title": "Duration",
          "content": "8 hours",
        },
        {
          "title": "Certification",
          "content": "Yes",
        }],
        "cover": response.thumb_url,
        "items": []
      };


      for (var i = 0; i < tree.length; i++) {
        obj.items.push({
          "title": tree[i].data.title,
          "content": tree[i].data.description
        });
      };

      return obj;
    },
    "get_initial_message": async function(params, bridgeWrapper) {
      var message = await bridgeWrapper(`auth/v1.0/user/me/preference/key/initial_message`);
      if (message) {
        setTimeout(function() {
          Sdk.dynamic.bridge(`auth/v1.0/user/me/preference/uid/${message.uid}`, null, "DELETE");
        }, 300);
      }
      return message;
    },
    "get_token_params": async function() {
      const hash = window.location.hash;
      const token = hash.split('/')[2];

      // console.log(token);

      Sdk.Api.authorization.signinByCredential({
        "type": "Bearer",
        "access_token": token
      }).then(response => {
        // console.log('Logado', response);
        window.location.href = "#/inicio"
      }).catch(error => {
        // console.log(error);
      });

    },
    "get_player_activities": async function(params, bridgeWrapper) {
      //const registers = await bridgeWrapper(`cms/v1.0/learning/course/uid/${params.courseUid}/registers`);
      const status = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/status`);
      var interactionUid = status.activities.filter(act => act.uid === params.activityUid)[0].interaction_uid;
      const interaction = await bridgeWrapper(`cms/v1.0/learning/interaction/uid/${interactionUid}/details`);
      var player_activivites = {
        "registers": { result : [ status.register ]},
        "status": status,
        "interaction": interaction
      }

      const getConfigs = await configs();

      return {
        ...player_activivites,
        ...getConfigs
      }
    },
    "checkout_get_courses": async function(params, bridgeWrapper) {
      const { course, productUid } = params
      console.log({course, productUid})
      let courseData = {}
      var headers = {
        "Project-Key": Sdk.Api.projectKey,
        "Api-Env": Sdk.Api.enviroment,
        "Content-Type": "application/json"
      }
      if (Sdk.Api.authorization.user !== null) {
        headers["Authorization"] = `Bearer ${Sdk.Api.authorization.credential.accessToken}`
      }

      try {
        // const userStatus = await Sdk.dynamic.bridge(`cms/v1.0/learning/register/uid/${course}/status`)
        const userStatusReq = await fetch(`${Sdk.Api.domain}/cms/v1.0/learning/register/uid/${course}/status`, {
          method: 'GET',
          headers: headers
        });
        var userStatus = await userStatusReq.json();


        if (['PendingPayment', 'Active'].includes(userStatus.status)) {
          courseData.alreadyBoughtCourse = true
        }
      } catch (error) {
        // if(![404].includes(error.status)) {
        //   courseData.alreadyBoughtCourse = true
        // }
        // console.log(error);
     }

      // const productInfo = await Sdk.dynamic.bridge(`store/v1.0/product/uid/${productUid}`)

      var projectByDomainRequest = await fetch(`${Sdk.Api.domain}/auth/v1.0/project/domain/${window.location.host}`, {
        "headers": {
          "api-env": Sdk.Api.enviroment,
          "project-key": Sdk.Api.projectKey,
        },
        "method": "GET"
      });
      var projectByDomainResponse = await projectByDomainRequest.json();
  
      var projectUid = projectByDomainResponse.uid;


      const anonymousLogin = await fetch(`${Sdk.Api.domain}/auth/v1.1/signin/project/uid/${projectUid}/anonymous`, {
        method: 'POST',
        headers: {
          ...headers,
          "Authorization": `Bearer `
        }
      });

      var anonymousLoginResponse = await anonymousLogin.json();

      console.log(anonymousLoginResponse)

      const productInfoReq = await fetch(`${Sdk.Api.domain}/store/v1.0/product/uid/${productUid}`, {
        method: 'GET',
        headers: {
          ...headers,
          "Authorization": `Bearer ${anonymousLoginResponse.access_token}`
        }
      });

      var productInfo = await productInfoReq.json();

      // const purchaseAvailable = await Sdk.dynamic.bridge(`store/v1.0/transaction/available`)
      const purchaseAvailableReq = await fetch(`${Sdk.Api.domain}/store/v1.0/transaction/available`, {
        method: 'GET',
        headers: headers
      });

      var purchaseAvailable = await purchaseAvailableReq.json();


      if (Array.isArray(purchaseAvailable)) {
        const transaction = purchaseAvailable.find(transaction => transaction.products.find(product => product.uid === productUid))
        if (!!transaction && (transaction.status === 'Paid' || (transaction.payment_type === 'Card' && transaction.status === 'WaitingPayment')) ) {
          courseData.alreadyBoughtCourse = true
        }
      }
      

      // const userRegister = await Sdk.dynamic.bridge(`cms/v1.0/learning/register/uid/${course}/detail`)
      const userRegisterReq = await fetch(`${Sdk.Api.domain}/cms/v1.0/learning/register/uid/${course}/detail`, {
        method: 'GET',
        headers: headers
      });

      var userRegister = await userRegisterReq.json();

      // const productUid = userRegister.products[0]
      courseData = {
        ...courseData,
        data: {
          course: {...userRegister.course, ...productInfo, "price": `${productInfo.currency || 'R$'} ${productInfo.amount},00`},
          userRegister,
          productInfo,
          price: `${productInfo.currency || 'R$'} ${productInfo.amount},00`,
          uniqueName: productInfo.unique_name
        },
        isAuthenticated: Sdk.Api.authorization.authenticated
      }
      if (Sdk.Api.authorization.user !== null) {
        courseData.userInfo = Sdk.Api.authorization.user.detail
      }

      console.log(courseData)

      return courseData
    },
    "insert_dangerous_status": async function(params, bridgeWrapper) {
      const response = await bridgeWrapper(`cms/v1.1/learning/courses?register_status=active&register_status=pendingpayment`);
      const courses = response.result;

      for (var i = 0; i < courses.length; i++) {
        const status = await bridgeWrapper(`cms/v1.0/learning/register/uid/${courses[i].register.uid}/status`);
        if (status.nodes.filter(node => node.access_status === "PendingPayment").length > 0) {
          const mainCardActiveEl = document.querySelector('.rdp-component-main-card-wrapper[data-uid="' + courses[i].course.uid + '"] .is_active')
          const mainCardInactiveEl = document.querySelector('.rdp-component-main-card-wrapper[data-uid="' + courses[i].course.uid + '"] .is_inactive')
          if (mainCardActiveEl) {
            mainCardActiveEl.style.display = "none"
          }
          if (mainCardInactiveEl) {
            mainCardInactiveEl.style.display = "flex"
          }
        }
      }
      // console.log(courses)
    },
    "get_user_entities": async function(params, bridgeWrapper) {
      // const entities = await bridgeWrapper(`auth/v1.0/entity/items/available`)
      // return entities;
      // console.log('inside get entities')
      // console.log({params})
      var entities = [
        {
          "uid": "abc",
          "label": "Categorias",
          "children": [
            {
              "uid": "123",
              "label": "Categoria 1"
            },
            {
              "uid": "456",
              "label": "Categoria 2"
            },
            {
              "uid": "789",
              "label": "Categoria 3"
            }
          ]
        },
        {
          "uid": "def",
          "label": "Temáticas de conhecimento",
          "children": [
            {
              "uid": "101112",
              "label": "Temática 1"
            },
            {
              "uid": "131415",
              "label": "Temática 2"
            },
            {
              "uid": "161718",
              "label": "Temática 3"
            }
          ]
        }
      ]

      return {
        "filters": entities
      }
    },
    "get_user_notifications": async function(params, bridgeWrapper) {
      var temp = [];
      // var api = {"current_page":1,"total_pages":1,"total_results":1,"result":[{"uid":"6157b89d-da59-ec11-94f6-0050f2a7059f","origin_type":"SystemMessage","context_type":"Directory","context_uid":"804f9545-f152-ec11-94f6-0050f2a76280","target_type":"Project","target_uid":"7d35f6bc-f352-ec11-94f6-0050f2a76280","name":"Bem vindo Leonardo Silva!","description":"Agora você faz partes da empresa SEBRAE - Geral","annotation":null,"tags":[],"last_viewed_at":null,"created_at":"2021-12-10T17:00:04.5192039Z","updated_at":"2021-12-10T17:00:04.5191884Z"}],"next_page_query":null}
      const api = await bridgeWrapper(`cms/v1.0/user/data?origin=SystemMessage`);
      var result = api.result;

      for (var i = 0; i < result.length; i++) {
        temp.push({
          "uid": result[i].uid,
          "type": result[i].context_type,
          "read": result[i].last_viewed_at !== null,
          "message": result[i].description,
          "created_at": result[i].created_at
        })
      }

      var notifications = {
        "notifications": temp
      };

      // var notifications = {
      //   "notifications": [
      //     {
      //       "uid": "1",
      //       "type": "quiz",
      //       "message": "Você foi reprovado na atividade 'XPTO' do curso de Sustentabilidade",
      //       "read": false,
      //       "created_at": "2021-07-16T19:12:03.9269035Z"
      //     },
      //     {
      //       "uid": "2",
      //       "type": "course",
      //       "message": "Você foi matriculado no curso: Sustentabilidade.",
      //       "read": false,
      //       "created_at": "2021-07-16T19:12:03.9269035Z"
      //     },
      //     {
      //       "uid": "3",
      //       "type": "certificate",
      //       "message": "Você concluiu o curso: Finanças! Não esqueça de baixar seu certificado.",
      //       "read": false,
      //       "created_at": "2021-07-16T19:12:03.9269035Z"
      //     },
      //     {
      //       "uid": "4",
      //       "type": "course",
      //       "message": "Você iniciou o curso: Finanças!",
      //       "read": true,
      //       "created_at": "2021-07-16T19:12:03.9269035Z"
      //     },
      //     {
      //       "uid": "5",
      //       "type": "message",
      //       "message": "Boas vindas! Espero que você goste do conteúdo!",
      //       "read": true,
      //       "created_at": "2021-07-16T19:12:03.9269035Z"
      //     }
      //   ]
      // }

      const getConfigs = await configs();

      return {
        ...getConfigs,
        ...notifications
      }
    },

    "get_billboard_notifications": async function(params, bridgeWrapper) {
      const resp = await UserEvent.getBillboardNotifications({payload: {context_uid: params.registerUid}, onChangeState: () => {}});
      return {
        rows: resp.data || {},
        editable: resp.editable || false,
        canEdit: resp.canEdit || false,
        canDelete: resp.canDelete || false,
        canCreate: resp.canCreate || false,
        context_uid: params.registerUid,
      };
    },
    "get_courses_favorites": async function(params, bridgeWrapper, flowProps, config) {

      // console.log("///////cursos: get_courses_favorites")
      const coursesRequest = await bridgeWrapper(`cms/v1.0/learning/courses?register_status=active&register_status=pendingpayment`)
      // console.log("///////cursos: get_courses_favorites - recebido")
      const favoritesRequest = await bridgeWrapper(`cms/v1.0/user/data?context_type=course`);
      const courses = coursesRequest.result;
      const favorites = favoritesRequest.result.filter(fav => fav.origin_type === "UserSelection");

      var contexts = [];

      for (var i = 0; i < courses.length; i++) {
        var context = {
          "title": courses[i].course.title,
          "thumb": courses[i].course.thumb_url,
          "children": []
        }

        var tree = await bridgeWrapper(`cms/v1.0/learning/register/uid/${courses[i].register.uid}/nodes/tree`);

        for (var j = 0; j < favorites.length; j++) {
          if (favorites[j].context_uid === courses[i].course.uid) {
            var firstLevel = "";
            // var url = flowProps.url_schema.replace(":courseUid", courses[i].course.uid);

            for (var k = 0; k < tree.length; k++) {
              var childs = tree[k].childs;
              for (var l = 0; l < childs.length; l++) {
                var activities = childs[l].activities;
                for (var m = 0; m < activities.length; m++) {
                  if (activities[m].uid === favorites[j].target_uid) {
                    firstLevel = tree[k].uid;
                  }
                }
              }
            }

            var url;
            if (config.config.common.modality === "academies") {
              url = "/academia/player/trilha/:courseUid/registro/:registerUid/curso/:nodeUid/atividade/:activityUid";
              url = url.replace(":nodeUid", firstLevel);
            } else {
              url = "/player/curso/:courseUid/registro/:registerUid/atividade/:activityUid";
            };

            url = url.replace(":courseUid", courses[i].course.uid);
            url = url.replace(":registerUid", courses[i].register.uid);
            url = url.replace(":activityUid", favorites[j].target_uid);

            // console.log("TREE:", tree);
            // console.log("ACTIVITY:", favorites[j].target_uid);

            context.children.push({
              "title": favorites[j].name,
              "route": url
            })
          };
        };
        if (context.children.length > 0) {
          contexts.push(context)
        }
      }
      // console.log(contexts)

      return contexts;
    },
    "courses_load_reviews" : async function (params, bridgeWrapper, context)
    {
      if (context.inprogress == undefined) return;

      const userregisters = context.inprogress.map(p=> `register_uid=${p.registerUid}`);
      // removido filtro para utilização compartilhada
      // const reviews = await bridgeWrapper(`cms/v1.0/learning/register/review/tasks?state=active&status=failed&${userregisters.join("&")}`);
      const reviewsResult = await bridgeWrapper(`cms/v1.0/review/tasks/status/failed?filter_state=active`);
      const reviews = reviewsResult.result;

      context.inprogress.forEach(course => {
        const tasks = reviews.filter(r=> r.context_type == "CourseRegister" && r.context_uid == course.registerUid).map(r=> {
          return {
            title : r.flow.title,
            description : r.flow.description,
            route : `/player/curso/${course.uid}/registro/${r.context_uid}/atividade/${r.target_uid}`
          }
        });

        course.reviews = tasks;
        // context.reviewTasks[course.registerUid] = tasks;
      });

    },
    get_preferences_logotype: async function (params, bridgeWrapper) {
      var connectorUid = null;
      var project = Sdk.authorization.activeProject;
      var connectors = project.connectors;

      for (var i = 0; i < connectors.length; i++) {
        if (connectors[i].type === "Customization_1") {
          connectorUid = connectors[i].uid;
        }
      }

      if (connectorUid) {
        const connector = await bridgeWrapper(
          `auth/v1.1/connector/uid/${connectorUid}`
        );
        return connector.configuration.content_references[0].url;
      } else {
        return { error: true };
      }
    },
    get_course_info: async function (params, bridgeWrapper) {
      const course = await bridgeWrapper(
        `cms/v1.0/learning/course/uid/${params.uid}`
      );
      const status = await bridgeWrapper(
        `cms/v1.0/learning/register/uid/${params.registerUid}/status`
      );

      const getTranslation = () => {
        var local = window.localStorage.getItem(`rdp-active-language-${window.location.origin}`);
        if (local !== null) {
          if (local === "pt-br") return TranslationPTBR;
          if (local === "en") return TranslationEN;
        };

        return TranslationPTBR;
      }

      const translation = getTranslation();

      var progress = parseInt(
        (status.activities.filter((activity) =>
          ["Completed", "Passed"].includes(activity.status)
        ).length /
          status.activities.length) *
          100
      );
      var items = [
        {
          icon: "CalendarIcon",
          title: translation.course_detail.card_end_date,
          type: "date",
          value: format(
            new Date(status.register.interaction_end),
            "dd/MM/yyyy"
          ),
          enabled: true,
        },
        {
          icon: "ProgressIcon",
          title: translation.course_detail.card_progress,
          type: "progress",
          value: progress,
          enabled: true,
        },
      ];

      if (course && course.type === "EvaluativeContent") {
        items.push({
          icon: "ScoreIcon",
          title: "<b>Notas</b>",
          type: "score",
          value: {
            redirectTo: window.location.href + "/relatorio/notas",
            message: "Relatório de notas desta disciplina",
          },
          enabled: true,
        });
      }

      let rank_enabled = false;

      if (course && "properties" in course) {
        const rankingProperty = course.properties.find(prop => prop.name === "ranking_enabled");

        if (rankingProperty) {
          rank_enabled = rankingProperty.value === "true";
        }
      }

      if (course && rank_enabled) {
        items.push({
          icon: "TrophyIcon",
          title: "<b>Ranking</b>",
          type: "rank",
          value: {
            redirectTo: window.location.href + "/ranking",
            message: "Ranking geral com pontuação",
          },
          enabled: true,
        });
      }

      //TODO: Talvez no futuro alterar para que o UID do certificado esteja em $status.register.certificate_uid
      try {
	      //TODO: bridgeWrapper quebra a renderização por algum motivo, substituído por fetch
	      const resp = await fetch(
          `${Sdk.Api.domain}/cms/v1.0/learning/user/register/uid/${status.uid}/certificate?project_key=${Sdk.Api.authorization.projectKey}&api_env=${Sdk.Api.enviroment}`
        );

        if (resp.status === 200) {
          items.push({
            icon: "CertificateIcon",
            title: "<b>Certificado</b>",
            type: "certificate",
            value:
              progress === 100
                ? {
                  enabled: true,
                  message: "Visualizar/Download",
                  redirectTo: window.location.href + "/certificate",
                  background_color: "#cceedb",
                  color: "#00aa4c",
                  course: status.course,
                }
                : {
                  enabled: false,
                  message: "Certificado disponível após a conclusão do curso.",
                  background_color: "#f1f8ff",
                  color: "#4386f5",
                  course: status.course,
                },
            enabled: progress === 100,
          })
        }
      } catch (e) {
        console.error(e);
      }

      var obj = {
        items: items,
      };
      return obj;
    },
    "get_certificate_url": async function (params, bridgeWrapper) {
      const status = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/status`);
      var obj = {
        "url": `${Sdk.Api.domain}/cms/v1.0/learning/user/register/uid/${status.uid}/certificate?project_key=${Sdk.Api.authorization.projectKey}&api_env=${Sdk.Api.enviroment}`
      }
      return obj;
    },
    "get_dam_embed_url": async function(params, bridgeWrapper) {
      var url = `https://sebrae-dam.digitalpages.com.br/#/auth-with-token/pt_br/embed-user-files/${Sdk.authorization.activeProject.uid}/${Sdk.Api.authorization.credential.accessToken}`;
      return url;
    },
    get_certificate_info: async function (params, bridgeWrapper) {
      const status = await bridgeWrapper(
        `cms/v1.0/learning/register/uid/${params.registerUid}/status`
      );

      const username = Sdk.Api.authorization.user.detail.name;

      const progress = parseInt(
        (status.activities.filter((activity) =>
          ["Completed", "Passed"].includes(activity.status)
        ).length /
          status.activities.length) *
          100
      );

      if (progress !== 100) {
        window.location = window.location.href.replace("/certificate", "");
      }

      let connectorUid = null;
      let logo = null;
      var project = Sdk.authorization.activeProject;
      var connectors = project.connectors;

      for (var i = 0; i < connectors.length; i++) {
        if (connectors[i].type === "Customization_1") {
          connectorUid = connectors[i].uid;
        }
      }

      if (connectorUid) {
        const connector = await bridgeWrapper(
          `auth/v1.1/connector/uid/${connectorUid}`
        );

        logo = connector.configuration.content_references[0].url;
      }

      const obj = {
        username: username,
        course_title: status.course.title,
        hours: "80",
        date: format(new Date(), "MM/dd/yyyy"),
      };

      if (logo) {
        obj.logotype = logo;
      }

      return obj;
    },
    get_access_mode: async (params, bridgeWrapper) => {
      if (Sdk.Api.hasOwnProperty("authorization_token") || Sdk.Api.hasOwnProperty("authorization")) {
        const USER_ROLES = {
          REVIEWER: "reviewer",
          REVIEWER_ADMIN: "reviewadmin",
          REVIEWER_CONTRIBUTOR: "reviewcontributor",
        }
        const token = Sdk.Api.authorization_token || Sdk.authorization.credential.accessToken;
        const user = jwtDecode(token);

        if (user) {
          let roles = [];
          if (user.role && Array.isArray(user.role)) {
            roles = user.role.map(role => role.toString().toLowerCase())
          } else if (user.role && typeof user.role === "string") {
            roles.push(user.role.toString().toLowerCase())
          }

          if (roles.includes(USER_ROLES.REVIEWER_ADMIN) ||
            roles.includes(USER_ROLES.REVIEWER_CONTRIBUTOR) ||
            roles.includes(USER_ROLES.REVIEWER)) {
            return "full";
          } else {
            return ""
          }
        } else {
          return ""
        }
      }

      return "";
    },
    get_iframe_url: async () => {

      const token = Sdk.Api.authorization_token || Sdk.authorization.credential.accessToken;

      return `https://manager.euconquisto.com/#/auth-with-credentials/${token}`
    },
    get_is_reviewer: async (params, bridgeWrapper) => {
      if (Sdk.Api.hasOwnProperty("authorization_token") || Sdk.Api.hasOwnProperty("authorization")) {
        const USER_ROLES = {
          REVIEWER: "reviewer",
          REVIEWER_ADMIN: "reviewadmin",
          REVIEWER_CONTRIBUTOR: "reviewcontributor",
        }
        const token = Sdk.Api.authorization_token || Sdk.authorization.credential.accessToken;
        const user = jwtDecode(token);

        if (user) {
          let roles = [];
          if (user.role && Array.isArray(user.role)) {
            roles = user.role.map(role => role.toString().toLowerCase())
          } else if (user.role && typeof user.role === "string") {
            roles.push(user.role.toString().toLowerCase())
          }

          return roles.includes(USER_ROLES.REVIEWER_ADMIN) ||
            roles.includes(USER_ROLES.REVIEWER_CONTRIBUTOR) ||
            roles.includes(USER_ROLES.REVIEWER);
        } else {
          return false;
        }
      }

      return false;
    },
    get_report_score: async (params, bridgeWrapper) => {
      var roles = Sdk.Api.authorization.user.roles;
      var isReviewer = false;
      if (roles) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i].type === "ReviewAdmin" || roles[i].type === "ReviewContributor") {
            isReviewer = true;
          }
        }
      }

      if (isReviewer) {
        let resp = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/report/scores/reviewer?page_size=500000`);
        let data = resp.result;
        data = data.map(async score => {
          let node_score_sum = 0;

          try {
            const response = await fetch(`${Sdk.Api.domain}/auth/v1.0/user/uid/${score.user_uid}`, {
              method: 'GET',
              headers: {
                "Project-Key": Sdk.Api.projectKey,
                "Api-Env": Sdk.Api.enviroment,
                "Authorization": `Bearer ${Sdk.Api.authorization.credential.accessToken}`,
                "Content-Type": "application/json"
              },
            });

            const user = await response.json();

            if (user && "uid" in user) {
              score.user_name = user.detail.name;

              if (user.roles) {
                let isStudent = true;
                for (const role of user.roles) {
                  if (role.type === 'ReviewContributor' || role.type === 'ReviewAdmin' || role.type === 'AdministratorGlobal') {
                    isStudent = false;
                    break;
                  }
                }

                if (isStudent) {
                  score.nodes = score.nodes.map((node) => {
                    const { activity_scores = [] } = node;

                    let activities_score_sum = 0;

                    if (activity_scores.length > 0) {
                      activity_scores.map((activity) => {
                        let score = activity.score || 0;

                        if (activity.score_weight !== null) {
                          score = (score * activity.score_weight) / 10;
                        }

                        activities_score_sum += score;

                        const scoreParts = String(activity.score).split('.');
                        if (scoreParts.length > 1) {
                          activity.score = activity.score.toFixed(2);
                        }
                      });
                    }

                    if (activities_score_sum > 0) {
                      switch (String(node.type_formula_score).toLowerCase()) {
                        case 'sum':
                          node.node_score = parseFloat(activities_score_sum.toFixed(2));
                          break;
                        case 'average':
                          node.node_score = parseFloat((activities_score_sum / activity_scores.length).toFixed(2));
                          break;
                        default:
                          node.node_score = 0;
                      }
                    } else {
                      node.node_score = 0;
                    }

                    node_score_sum += node.node_score

                    return node;
                  });

                  if (node_score_sum > 0) {
                    switch (String(score.type_formula_score).toLowerCase()) {
                      case 'sum':
                        score.course_score = parseFloat(node_score_sum.toFixed(2));
                        break;
                      case 'average':
                        score.course_score = parseFloat((node_score_sum / score.nodes.length).toFixed(2));
                        break;
                      default:
                        score.course_score = 0;
                    }
                  } else {
                    score.course_score = 0;
                  }

                  return score;
                } else {
                  return null;
                }
              }
            }

            return null;
          } catch (e) {
            console.error(e);
            return null;
          }
        });

        let rows = await Promise.all(data);
        return rows.filter(row => row != null);

      } else {
        let resp = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/report/scores`);

        let node_score_sum = 0;

        resp.nodes = resp.nodes.map((node) => {
          const { activity_scores = [] } = node;

          let activities_score_sum = 0;

          if (activity_scores.length > 0) {
            activity_scores.map((activity) => {
              let score = activity.score || 0;

              if (activity.score_weight !== null) {
                score = (score * activity.score_weight) / 10;
              }

              activities_score_sum += score;

              const scoreParts = String(activity.score).split('.');
              if (scoreParts.length > 1) {
                activity.score = activity.score.toFixed(2);
              }
            });
          }

          if (activities_score_sum > 0) {
            switch (String(node.type_formula_score).toLowerCase()) {
              case 'sum':
                node.node_score = parseFloat(activities_score_sum.toFixed(2));
                break;
              case 'average':
                node.node_score = parseFloat((activities_score_sum / activity_scores.length).toFixed(2));
                break;
              default:
                node.node_score = 0;
            }
          } else {
            node.node_score = 0;
          }

          node_score_sum += node.node_score

          return node;
        });

        if (node_score_sum > 0) {
          switch (String(resp.type_formula_score).toLowerCase()) {
            case 'sum':
              resp.course_score = parseFloat(node_score_sum.toFixed(2));
              break;
            case 'average':
              resp.course_score = parseFloat((node_score_sum / resp.nodes.length).toFixed(2));
              break;
            default:
              resp.course_score = 0;
          }
        } else {
          resp.course_score = 0;
        }

        return [resp];
      }
    },
    get_course_uid: async (params, bridgeWrapper) => {
      return params.uid;
    },
    get_register_uid: async (params, bridgeWrapper) => {
      return params.uid;
    },
    get_tree_with_no_empty_nodes: async (params, bridgeWrapper) => {
      let resp = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/nodes/tree`);

      // Previne que nós vazios sejam renderizados no app
      function filterEmptyNodes(nodes) {
        let nodesCopy = null;
        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          // Verifica se as sub-árvores estão vazias
          if (node.childs !== null) {
            node.childs = filterEmptyNodes(node.childs);
          }

          // Se o nó não possuir filhos ou atividades ele não deve ser incluído no app
          if ((node.childs !== null) || ("activities" in node && node.activities && node.activities.length > 0)) {
            if (nodesCopy === null) {
              nodesCopy = [];
            }
            nodesCopy.push(node);
          }
        }

        return nodesCopy;
      }

      if (resp.length > 0) {
        return filterEmptyNodes(resp);
      } else {
        return [];
      }
    },
    get_academy_tree_with_no_empty_nodes: async (params, bridgeWrapper) => {

      let resp = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/nodes/tree`);

      // Previne que nós vazios sejam renderizados no app
      function filterEmptyNodes(nodes) {
        let nodesCopy = null;
        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          // Verifica se as sub-árvores estão vazias
          if (node.childs !== null) {
            node.childs = filterEmptyNodes(node.childs);
          }

          // Se o nó não possuir filhos ou atividades ele não deve ser incluído no app
          if ((node.childs !== null) || ("activities" in node && node.activities && node.activities.length > 0)) {
            if (nodesCopy === null) {
              nodesCopy = [];
            }
            nodesCopy.push(node);
          }
        }

        return nodesCopy;
      }

      if (resp.length > 0) {
        return filterEmptyNodes(resp).filter(item => item.uid === params.cursoUid);
      } else {
        return [];
      }
    },
    get_dynamic_recovery_password_config: async (params, bridgeWrapper, _, config) => {
      let options = {
        loadingForm: false
      };

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "dynamic_recovery_password" in configData) {
          const {
            types = [],
            enabled_types = [],
          } = configData.dynamic_recovery_password;

          let formTypes = types.filter(form => enabled_types.includes(form.type));

          if (formTypes.length > 0) {
            options = {
              formTypes,
            };
          }
        }
      }

      return options;
    },
    get_show_first_access_button: async (params, bridgeWrapper, _, config) => {
      let show_first_access_button = false;

     if (config && "config" in config) {
       const configData = config.config;
       if (configData && "first_access" in configData) {
         const {
           show_first_access_button = false,
         } = configData.first_access;

         return show_first_access_button;
       }
     }

      return show_first_access_button;
    },
    get_signup_query_params_default_values: async (params, bridgeWrapper) => {
      const searchParams = window.location.href.split('?')[1];
      if (searchParams) {
        const urlSearchParams = new URLSearchParams(searchParams);

        if (urlSearchParams.has('default_values')) {
          try {
            const decodedBase64 = atob(urlSearchParams.get('default_values'));
            return JSON.parse(decodedBase64);
          } catch (e) {
            console.error(e);
          }
        }
      }
    },
    get_login_placeholder_customization_config: async (params, bridgeWrapper, _, config) => {
      let loginPlaceholder;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "login" in configData) {
          const {
            login_placeholder,
          } = configData.login;

          loginPlaceholder = login_placeholder;
        }
      }

      return loginPlaceholder;
    },
    get_login_type_customization_config: async (params, bridgeWrapper, _, config) => {
      let loginType;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "login" in configData) {
          const {
            login_type,
          } = configData.login;

          loginType = login_type;
        }
      }

      return loginType;
    },
    get_show_register_button: async (params, bridgeWrapper, _, config) => {
      let show = false;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "login" in configData) {
          const {
            show_register_button,
          } = configData.login;

          show = show_register_button;
        }
      }

      return show;
    },
    get_show_course_tabs: async (params, bridgeWrapper, _, config) => {
      let show = false;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "courses" in configData) {
          const {
            show_course_tabs,
          } = configData.courses;

          show = show_course_tabs;
        }
      }

      return show;
    },
    get_show_login_button: async (params, bridgeWrapper, _, config) => {
      let show = false;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "register" in configData) {
          const {
            show_login_button,
          } = configData.register;

          show = show_login_button;
        }
      }

      return show;
    },
    get_disable_email_confirmation: async (params, bridgeWrapper, _, config) => {
      let disable = false;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "register" in configData) {
          const {
            auto_login = false,
          } = configData.register;

          disable = auto_login;
        }
      }

      return disable;
    },
    get_register_additional_fields: async (params, bridgeWrapper, _, config) => {
      let fields = [];

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "register" in configData) {
          var {
            additional_fields = [],
          } = configData.register;

          if (additional_fields === "[]") additional_fields = [];

          fields = additional_fields.map(field => {
            if (field === "cpf") {
              return {
                "name": "cpf",
                "placeholder": "Digite seu CPF*",
                "type": "text",
                "mask": "cpf"
              }
            }

            if (field === "birthday") {
              return {
                "name": "birthday",
                "placeholder": "Digite sua data de nascimento*",
                "type": "date",
                "mask": "date"
              }
            }

            if (field === "rg") {
              return {
                "name": "rg",
                "placeholder": "Digite seu RG*",
                "type": "text",
                "mask": "rg"
              }
            }
          });
        }
      }

      return fields;
    },
    check_pending_terms: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const {
        data: {
          flow_props: {
            identifier = "",
          }
        }
      } = flow;

      const getComposerPlayerPreviewUrl = (uid) => {
        if (Sdk.authorization.credential) {
          let token = Sdk.Api.authorization.credential.accessToken;
          const optionObj = {
            content_uid: uid,
            access_token: token,
          };
          const options = window.btoa(JSON.stringify(optionObj));

          return `${Sdk.Api.domain}/product/composer_player/current/${Sdk.Api.projectKey}/p/${Sdk.Api.authorization.activeProject.uid}/${Sdk.Api.enviroment === "production" ? "p" : "h"}/?custom_options=${options}`;
        }
      }

      const directory = await bridgeWrapper(`auth/v1.0/directory/uid/${Sdk.Api.authorization.activeProject.directory.uid}`, null, "GET")

      if (directory) {
        if (Sdk.authorization.credential) {
          let resp;
          const termsPolicies = directory.connectors.find(connector => connector.type === "Policies_1") || {};

          if (termsPolicies && termsPolicies?.uid) {
            resp = await bridgeWrapper(`auth/v1.0/policies/connector/uid/${termsPolicies?.uid}/terms?last_version=true&user_unanswered_terms=true`, null, "GET");
          }

          // TODO: Utilizar quando o backend estiver pronto
          // const content = await bridgeWrapper(`auth/v1.0/policies/connector/uid/${termsPolicies?.uid}/term/uid/${resp[0].uid}/content`, null, "GET");

          if (resp && resp.length > 0) {
            return resp.filter(term => {
              const {
                required_context = "",
              } = term;
              return  required_context.toLowerCase() === identifier.toLowerCase() || required_context.toLowerCase() === "all";
            }).map(term => {
              const current_version = term.versions.find(version => version.current_version);
              term.url = getComposerPlayerPreviewUrl(current_version.content_uid);
              return term;
            });
          }
        }
      }

      return [];
    },
    get_course_tree_customization_configs: async (params, bridgeWrapper, _, config) => {
      let performActivitiesSequentially = false;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "course_tree" in configData) {
          const {
            perform_activities_sequentially = false,
          } = configData.course_tree;

          performActivitiesSequentially = perform_activities_sequentially;
        }
      }

      return performActivitiesSequentially;
    },
    get_course_tree_coming_soon_label_configs: async (params, bridgeWrapper, _, config) => {
      let configValue;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "course_tree" in configData) {
          const {
            coming_soon_label = false,
          } = configData.course_tree;

          configValue = coming_soon_label;
        }
      }

      return configValue;
    },
    get_course_tree_coming_soon_date_label_configs: async (params, bridgeWrapper, _, config) => {
      let configValue;

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "course_tree" in configData) {
          const {
            coming_soon_date_label = false,
          } = configData.course_tree;

          configValue = coming_soon_date_label;
        }
      }

      return configValue;
    },
    check_pending_subscription: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      if (window.localStorage.getItem(window.location.origin + "RDP_COURSE_SUBSCRIBE_DONE") !== null && window.localStorage.getItem(window.location.origin + "RDP_COURSE_SUBSCRIBE_DONE") === "true") {
        window.localStorage.removeItem(window.location.origin + "RDP_COURSE_SUBSCRIBE");
        window.localStorage.removeItem(window.location.origin + "RDP_COURSE_SUBSCRIBE_DONE");
      } else if (window.localStorage.getItem(window.location.origin + "RDP_COURSE_SUBSCRIBE") !== null && window.localStorage.getItem(window.location.origin + "RDP_COURSE_SUBSCRIBE") === "") {
        window.localStorage.removeItem(window.location.origin + "RDP_COURSE_SUBSCRIBE");
      }
      return window.localStorage.getItem(window.location.origin + "RDP_COURSE_SUBSCRIBE") !== null;
    },
    check_syncing_courses: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      return window.localStorage.getItem(window.location.origin + "RDP_COURSE_SUBSCRIBE") !== null;
    },
    check_finish_syncing_courses_catalog: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      let rdp_course_catalog_subscribe = window.localStorage.getItem(window.location.origin + "RDP_COURSE_CATALOG_SUBSCRIBE");
      return rdp_course_catalog_subscribe !== null;
    },
    get_in_progress_courses: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const cards = [];
      const req = await bridgeWrapper(`cms/v1.1/learning/courses?page_size=500`);
      const courses = req.result;

      courses.filter(c => c.status.toLowerCase() !== "blocked").forEach(element => {
        cards.push({
          "uid": element.course.uid,
          "registerUid": element.register.uid,
          "register": element.register,
          "title": element.course.title,
          "description": element.course.description,
          "thumb_url": element.course.thumb_url,
          "entities": element.course.entities,
          "progress": (() => {
            if (element.activities && element.activities.total_activities) {
              let progress = parseInt(((element.activities.total_status_completed + element.activities.total_status_passed) / element.activities.total_activities) * 100);
              return isFinite(progress) ? progress : 0;
            }
            return 0;
          })(),
          "status": (() => {
            if (element.activities && element.activities.total_activities && element.activities.total_status_not_attempted != null) {
              return element.activities.total_status_not_attempted == element.activities.total_activities ? 'not_started' : (element.activities.total_activities == (element.activities.total_status_completed + element.activities.total_status_passed)) ? 'finished' : 'in_progress';
            }
            return 'not_started';
          })(),
          "paymentStatus": element.status,
          "reviews": element.review_tasks && element.review_tasks.length > 0 ? ([element.review_tasks[element.review_tasks.length - 1]].filter(p => p.status == 'Failed').map(p => (p.flow = element.review_flows.find(f => f.uid == p.review_flow_uid), { 'title': p.flow.title, 'description': p.flow.description, 'status': p.status, 'route': `/player/curso/${element.course.uid}/atividade/${p.target_uid}` }))) : [],
          "first_project_approved": (() => {
            if (element.activities && element.activities.total_status_completed != null && element.activities.total_status_passed != null) {
              return (element.activities.total_status_completed + element.activities.total_status_passed) === 1;
            }
            return false;
          })(),
        })
      })

      return cards;
    },
    get_blocked_courses: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const cards = [];

      // var req = await Offliner.resolveRequest({
      //   "db_name": "all-courses",
      //   "request": bridgeWrapper(`cms/v1.0/learning/courses`, null, "GET")
      // });

      var req = await bridgeWrapper(`cms/v1.1/learning/courses?page_size=500`);
      const courses = req.result;

      courses.filter(c => c.status.toLowerCase() === "blocked").forEach(element => {
        cards.push({
          "uid": element.course.uid,
          "registerUid": element.register.uid,
          "register": element.register,
          "title": element.course.title,
          "description": element.course.description,
          "thumb_url": element.course.thumb_url,
          "entities": element.course.entities,
          "progress": (() => {
            if (element.activities && element.activities.total_activities) {
              let progress = parseInt(((element.activities.total_status_completed + element.activities.total_status_passed) / element.activities.total_activities) * 100);
              return isFinite(progress) ? progress : 0;
            }
            return 0;
          })(),
          "status": (() => {
            if (element.activities && element.activities.total_activities && element.activities.total_status_not_attempted != null) {
              return element.activities.total_status_not_attempted == element.activities.total_activities ? 'not_started' : (element.activities.total_activities == (element.activities.total_status_completed + element.activities.total_status_passed)) ? 'finished' : 'in_progress';
            }
            return 'not_started';
          })(),
          "paymentStatus": element.status,
          "reviews": element.review_tasks && element.review_tasks.length > 0 ? ([element.review_tasks[element.review_tasks.length - 1]].filter(p => p.status == 'Failed').map(p => (p.flow = element.review_flows.find(f => f.uid == p.review_flow_uid), { 'title': p.flow.title, 'description': p.flow.description, 'status': p.status, 'route': `/player/curso/${element.course.uid}/atividade/${p.target_uid}` }))) : [],
          "first_project_approved": (() => {
            if (element.activities && element.activities.total_status_completed != null && element.activities.total_status_passed != null) {
              return (element.activities.total_status_completed + element.activities.total_status_passed) === 1;
            }
            return false;
          })(),
        })
      })

      return cards;
    },
    get_course_tabs: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const getTranslation = () => {
        var local = window.localStorage.getItem(`rdp-active-language-${window.location.origin}`);
        if (local !== null) {
          if (local === "pt-br") return TranslationPTBR;
          if (local === "en") return TranslationEN;
        };

        return TranslationPTBR;
      }

      const translation = getTranslation();

      const tabs = [
        {
          "identifier": "in_progress",
          "title": translation.courses.breadcrumb_filter_inprogress,
          "size": 1
        },
      ];

      // console.log("///////cursos: get_course_tabs")
      const req = await bridgeWrapper(`cms/v1.1/learning/courses?page_size=500`);
      const courses = req.result;
      // console.log("///////cursos: get_course_tabs - recebido")

      let inactive = courses.filter(c => c.status.toLowerCase() === "blocked").length;
      if (inactive > 0) {
        tabs.push({
          "identifier": translation.courses.breadcrumb_filter_inactive,
          "title": "Inativos",
          "size": inactive
        })
      }
    },
    get_course_tabs_group: async (
      params,
      bridgeWrapper,
      contextFinal,
      config,
      flow,
      appContext
    ) => {
      const categorySchemas = await bridgeWrapper(
        "auth/v1.1/entity/schema/available?type=category"
      );
      console.log("RESULT:");
      console.log(categorySchemas.result);
      var tabs = [];

      categorySchemas.forEach(async (category) => {
        const entities = [];

        const schemaItems = await bridgeWrapper(
          `auth/v1.0/entity/management/schema/uid/${category.uid}/items`
        );

        schemaItems.map((item) => {
          const tab = item.data && item.data.tab == 'true' ? true : false
          const icon = item.data && item.data.icon != ''
            ? item.data.icon
            : "<svg width='34' height='23' viewBox='0 0 44 33' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill='#ff5b00' fill-rule='evenodd' clip-rule='evenodd' d='M22 0L0 10.6529L7.61762 14.3453V26.6179L22 33L36.3824 26.6179V14.3453L39.726 12.7257V22.6941H41.7128V11.7616L44 10.6529L22 0ZM34.3859 25.3742L22 30.8405L9.6141 25.3742V15.3094L22 21.3059L34.3859 15.3094V25.3742ZM22 19.1078L21.8546 19.0403L4.53568 10.6529L21.9806 2.19807L39.4256 10.6529L22 19.1078Z'/></svg>";

          if (tab) {
            tabs.push({
              identifier: `${item.uid}`,
              title: `${item.name}`,
              size: 0,
              uid: item.uid,
              ...(icon && { icon }),
              listData: async () => this.get_courses_from_category(item.uid),
            });
          }
        })
      });

      return tabs;
    },
    get_courses_registers_catalog: (resp) => {
      return resp;
    },
    get_register_status: (resp) => {
      return resp.course
    },
    get_course_register_title: (resp) => {
      return resp.course.title + ' / ' + resp.register.name
    },
    get_academy_course_breadcrumb: async (params, bridgeWrapper) => {
      // let course = await bridgeWrapper(`cms/v1.0/learning/course/uid/${params.uid}`);
      // /cms/v1.0/learning/register/uid/dd5d7cac-ffc7-ed11-9f73-002248df3a7c/status
      let nodes = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/nodes/tree`);
      let status = await bridgeWrapper(`cms/v1.0/learning/register/uid/${params.registerUid}/status`);

      var node = nodes.find(node => node.uid === params.cursoUid);

      // console.log(node);
      // console.log(status);

      return {
        "title": node.data.title,
        "background_image": node.data.thumb,
        "progress": Number(node.progress.toFixed())
      }
      // return resp.course.title + ' / ' + resp.register.name
    },
    check_page_course_title: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const getTranslation = () => {
        var local = window.localStorage.getItem(`rdp-active-language-${window.location.origin}`);
        if (local !== null) {
          if (local === "pt-br") return TranslationPTBR;
          if (local === "en") return TranslationEN;
        };

        return TranslationPTBR;
      }

      const translation = getTranslation();

      let title = {
        "text": translation.courses.breadcrumb_title,
        "icon": null
      };

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "sidebar" in configData) {
          const {
            course_menu_label,
          } = configData.sidebar;

          if (course_menu_label) {
            title.text = translation.courses.breadcrumb_title;
          }
        }
      }

      return title;
    },
    get_menu_items: (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const getRoles = Sdk.Api.authorization.user?.roles || [];
      const findAdminUser = getRoles.find((user) => user.type === "AdministratorGlobal");
      const isAdmin = findAdminUser !== undefined ? true : false;
      const isDesktop = window.innerWidth > 768;

      const getTranslation = () => {
        var local = window.localStorage.getItem(`rdp-active-language-${window.location.origin}`);
        if (local !== null) {
          if (local === "pt-br") return TranslationPTBR;
          if (local === "en") return TranslationEN;
        };

        return TranslationPTBR;
      }

      const translation = getTranslation();

      let items = [
        {
          "title": "Revisão",
          "visible": false,
          "active": false,
          "icon": "<svg width='44' height='33' viewBox='0 -5 20 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill='#000000' d='M11.0983 5.58753C10.1834 6.50246 10.1834 7.98692 11.0983 8.90184C12.0132 9.81681 13.4978 9.81666 14.4126 8.90184C15.3264 7.98809 15.3264 6.50129 14.4126 5.58753C13.4976 4.67261 12.013 4.67268 11.0983 5.58753ZM11.9268 6.4161C12.3838 5.95915 13.127 5.95918 13.584 6.4161C14.0408 6.87298 14.0408 7.61636 13.584 8.07328C13.127 8.53019 12.3837 8.53015 11.9268 8.07328C11.4699 7.61632 11.4699 6.87302 11.9268 6.4161Z'/><path fill='#000000' d='M0.171933 19.828C0.322038 19.9781 0.541942 20.0358 0.747043 19.9776C0.79493 19.9641 1.93461 19.64 3.20693 19.1973C5.87527 18.269 6.3768 17.7675 6.54163 17.6027C7.67458 16.4697 7.68349 14.6326 6.56963 13.4878L7.89183 14.81C8.05338 14.9715 8.29512 15.0252 8.51096 14.9446C9.68435 14.5068 10.6943 14.1709 11.6119 13.8287L13.9196 17.5042C14.0435 17.7014 14.2745 17.8091 14.5093 17.7716C14.7416 17.7345 14.9294 17.5622 14.9862 17.3338L16.6002 10.8493C16.699 10.7556 16.7982 10.659 16.8981 10.5591C18.5671 8.89006 19.4451 6.52388 19.8001 4.18125C20.1031 2.182 19.9732 0.63032 19.9675 0.565247C19.9428 0.28191 19.7181 0.0572404 19.4347 0.0325158C19.3696 0.0268131 17.818 -0.103099 15.8187 0.199885C13.4753 0.555014 11.1096 1.43319 9.44089 3.10192C9.34125 3.20156 9.24489 3.3005 9.15142 3.39893L2.67017 5.01919C2.44234 5.07614 2.27056 5.26363 2.23365 5.49556C2.19673 5.7275 2.30192 5.95904 2.50085 6.08388L6.17154 8.38737C6.01057 8.81882 5.28872 10.8634 5.05526 11.489C4.97507 11.704 5.02768 11.946 5.1899 12.1082L6.5121 13.4303C5.36727 12.3166 3.53014 12.3254 2.39723 13.4583C2.2324 13.6232 1.73087 14.1247 0.802508 16.793C0.359926 18.0653 0.0358495 19.205 0.0222568 19.2529C-0.0357464 19.4576 0.0215147 19.6776 0.171933 19.828ZM7.90242 4.91897C7.36324 5.69117 6.9628 6.4608 6.61158 7.28007L4.28872 5.82241L7.90242 4.91897ZM18.3616 5.39401L14.6061 1.63844C16.3705 1.19235 18.0201 1.15899 18.8232 1.177C18.8544 2.53087 18.7094 4.02927 18.3616 5.39401ZM12.7211 13.3878C13.5394 13.0369 14.3083 12.6369 15.0797 12.0984L14.1803 15.7118L12.7211 13.3878ZM6.28395 11.545C7.51846 8.17859 7.92496 6.27495 10.2695 3.93041C11.1535 3.04634 12.2359 2.44217 13.341 2.03044L17.9678 6.65727C17.5623 7.74253 16.9612 8.8387 16.0695 9.73039C13.7347 12.0652 11.8496 12.4711 8.45495 13.7159L6.28395 11.545ZM1.46406 18.5359C1.58831 18.1392 1.74239 17.6637 1.91293 17.1737C2.67002 14.9987 3.08428 14.4313 3.22724 14.2883C3.91226 13.6034 5.02675 13.6036 5.71157 14.2883C6.39648 14.9733 6.39648 16.0877 5.71157 16.7726C5.56842 16.9158 5.00019 17.3305 2.82114 18.0887C2.33258 18.2587 1.85918 18.4121 1.46406 18.5359Z'/></svg>",
          "action": {
            "type": "link",
            "target": "submissoes"
          }
        },
        {
          "title": "Catálogo",
          "visible": true,
          "active": false,
          "icon": "<svg width='34' height='34' viewBox='-6 -12 46 46' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill='#000000' fill-rule='evenodd' clip-rule='evenodd' d='M0 0V15.5429H15.1111V0H0ZM1.88889 13.6V1.94286H13.2222V13.6H1.88889Z'/><path fill='#000000' fill-rule='evenodd' clip-rule='evenodd' d='M18.8889 0V15.5429H34V0H18.8889ZM20.7778 13.6V1.94286H32.1111V13.6H20.7778Z'/><path fill='#000000' fill-rule='evenodd' clip-rule='evenodd' d='M0 18.4571H15.1111V34H0V18.4571ZM1.88889 20.4V32.0571H13.2222V20.4H1.88889Z'/><path fill='#000000' fill-rule='evenodd' clip-rule='evenodd' d='M18.8889 18.4571V34H34V18.4571H18.8889ZM20.7778 32.0571V20.4H32.1111V32.0571H20.7778Z'/></svg>",
          "action": {
            "type": "link",
            "target": "catalogo"
          }
        },
        {
          "title": "Academia",
          "visible": false,
          "active": false,
          "icon": "<svg width='44' height='33' viewBox='0 0 44 33' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill='#ff5b00' fill-rule='evenodd' clip-rule='evenodd' d='M22 0L0 10.6529L7.61762 14.3453V26.6179L22 33L36.3824 26.6179V14.3453L39.726 12.7257V22.6941H41.7128V11.7616L44 10.6529L22 0ZM34.3859 25.3742L22 30.8405L9.6141 25.3742V15.3094L22 21.3059L34.3859 15.3094V25.3742ZM22 19.1078L21.8546 19.0403L4.53568 10.6529L21.9806 2.19807L39.4256 10.6529L22 19.1078Z'/></svg>",
          "action": {
            "type": "link",
            "target": "academia"
          }
        },
        {
          "title": translation.courses.menu_courses,
          "visible": true,
          "active": false,
          "icon": "<svg width='44' height='33' viewBox='0 0 44 33' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill='#ff5b00' fill-rule='evenodd' clip-rule='evenodd' d='M22 0L0 10.6529L7.61762 14.3453V26.6179L22 33L36.3824 26.6179V14.3453L39.726 12.7257V22.6941H41.7128V11.7616L44 10.6529L22 0ZM34.3859 25.3742L22 30.8405L9.6141 25.3742V15.3094L22 21.3059L34.3859 15.3094V25.3742ZM22 19.1078L21.8546 19.0403L4.53568 10.6529L21.9806 2.19807L39.4256 10.6529L22 19.1078Z'/></svg>",
          "action": {
            "type": "link",
            "target": "inicio"
          }
        },
        {
          "title": "Telegram",
          "visible": false,
          "active": false,
          "icon": "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='448' height='448' viewBox='-60 -60 560 560'><path fill='#000' d='M297.25 326.75l36.75-173.25c3.25-15.25-5.5-21.25-15.5-17.5l-216 83.25c-14.75 5.75-14.5 14-2.5 17.75l55.25 17.25 128.25-80.75c6-4 11.5-1.75 7 2.25l-103.75 93.75-4 57c5.75 0 8.25-2.5 11.25-5.5l27-26 56 41.25c10.25 5.75 17.5 2.75 20.25-9.5zM448 224c0 123.75-100.25 224-224 224s-224-100.25-224-224 100.25-224 224-224 224 100.25 224 224z'></path></svg>",
          "action": {
            "type": "link",
            "target": "telegram"
          }
        },
        {
          "title": "Processo seletivo",
          "visible": false,
          "active": false,
          "icon": "<svg width='27' height='26' viewBox='0 0 30 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.49707 26.0002H25.5029C25.9155 26.0002 26.25 25.6658 26.25 25.2532V22.0003C26.25 21.5146 26.0828 21.0385 25.7791 20.6595L22.1655 16.1492C21.5469 15.3772 20.3755 15.3709 19.7484 16.1346L18.3849 17.795L15.9583 14.3142C15.9496 14.3018 15.9406 14.2896 15.9311 14.2776C15.4978 13.7306 14.9065 13.3553 14.2471 13.1929V9.17597H17.2062V10.6034C17.2062 11.016 17.5407 11.3504 17.9533 11.3504H24.169C24.8408 11.3504 25.1609 10.5386 24.6971 10.075L22.8434 8.22127L24.8254 6.23924C25.3032 5.76166 24.9505 4.96379 24.2973 4.96379H19.5038V3.53634C19.5038 3.12376 19.1693 2.78927 18.7567 2.78927H14.2471V1.24731C14.2471 0.834732 13.9126 0.500244 13.5 0.500244C13.0874 0.500244 12.7529 0.834732 12.7529 1.24731V13.1927C12.0932 13.355 11.5017 13.7304 11.0684 14.2775C11.0589 14.2895 11.0499 14.3017 11.0411 14.3141L8.61491 17.7946L7.25155 16.1345C6.62352 15.3697 5.45201 15.3784 4.83453 16.1491L1.2209 20.6594C0.917244 21.0385 0.75 21.5147 0.75 22.0003V25.2532C0.75 25.6658 1.08449 26.0002 1.49707 26.0002ZM18.7004 9.17592C19.2139 9.17592 19.5038 8.81519 19.5038 8.42885V6.45788H22.4937L21.2586 7.69294C20.967 7.98445 20.9668 8.45774 21.2586 8.74944L22.3654 9.85625H18.7004V9.17592ZM14.2471 4.28341H18.0097V7.68178H14.2471V4.28341ZM20.9031 17.0828C20.9282 17.0524 20.9746 17.0523 20.9994 17.0834L24.6131 21.5937C24.7052 21.7087 24.7559 21.8531 24.7559 22.0003V24.5061H23.0637L19.2727 19.0682L20.9031 17.0828ZM12.2526 15.1891C12.896 14.3974 14.1041 14.3981 14.747 15.1891L21.2423 24.5061H19.0624L16.6999 20.9192C16.4729 20.5747 16.0097 20.4792 15.6651 20.7062C15.3205 20.9332 15.2251 21.3965 15.4521 21.741L17.2733 24.5061H9.72675L11.548 21.741C11.7749 21.3965 11.6796 20.9332 11.335 20.7062C10.9904 20.4792 10.5271 20.5746 10.3001 20.9192L7.93761 24.5061H5.75766L12.2526 15.1891ZM2.24414 22.0003C2.24414 21.8531 2.29489 21.7087 2.38693 21.5937L6.00056 17.0833C6.0275 17.0497 6.07412 17.0549 6.09688 17.0827L7.72719 19.068L3.93635 24.5061H2.24414V22.0003Z' fill='#4B618B'/></svg>",
          "action": {
            "type": "link",
            "target": "processo-seletivo"
          }
        },
        {
          "title": translation.courses.menu_favorites,
          "visible": true,
          "active": false,
          "icon": "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='320' height='448' viewBox='0 -40 320 550'><path fill={favoritesIconColor} d='M291 32c3.75 0 7.5 0.75 11 2.25 11 4.25 18 14.5 18 25.75v322.25c0 11.25-7 21.5-18 25.75-3.5 1.5-7.25 2-11 2-7.75 0-15-2.75-20.75-8l-110.25-106-110.25 106c-5.75 5.25-13 8.25-20.75 8.25-3.75 0-7.5-0.75-11-2.25-11-4.25-18-14.5-18-25.75v-322.25c0-11.25 7-21.5 18-25.75 3.5-1.5 7.25-2.25 11-2.25h262z'></path></svg>",
          "action": {
            "type": "link",
            "target": "favoritos"
          }
        },
        {
          "title": "Manager",
          "visible": isAdmin && isDesktop,
          "active": false,
          "icon": "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='1024' height='1024' viewBox='0 0 1024 1024'><path fill='#000' d='M984.48 232.384l-369.376-208.48c-50.272-28.384-136.672-28.416-187.040 0l-369.376 208.48c-28.256 15.968-43.776 38.304-43.776 62.944s15.552 46.976 43.776 62.912l369.376 208.512c25.152 14.208 58.368 22.016 93.504 22.016 35.168 0 68.384-7.84 93.536-22.016l369.376-208.512c28.256-15.936 43.808-38.272 43.808-62.912s-15.584-46.976-43.808-62.944zM967.648 328.48l-369.376 208.512c-39.616 22.368-113.792 22.4-153.408 0l-369.376-208.512c-16.768-9.472-26.368-21.568-26.368-33.152 0-11.616 9.6-23.68 26.368-33.184l369.376-208.512c19.808-11.2 47.776-17.6 76.672-17.6 28.928 0 56.896 6.432 76.704 17.6l369.376 208.512c16.768 9.472 26.4 21.568 26.4 33.184 0.032 11.584-9.568 23.68-26.368 33.152zM984.48 451.168c-8.192-4.64-18.624-1.76-23.328 6.496-4.64 8.224-1.728 18.656 6.496 23.296 16.768 9.472 26.4 21.568 26.4 33.152s-9.632 23.68-26.4 33.152l-369.376 208.512c-41.536 23.456-111.808 23.488-153.408 0l-369.376-208.512c-16.768-9.472-26.368-21.568-26.368-33.152s9.6-23.68 26.368-33.152c8.224-4.64 11.136-15.072 6.496-23.296-4.672-8.256-15.136-11.168-23.328-6.496-28.256 15.936-43.776 38.304-43.776 62.944s15.52 47.008 43.776 62.944l369.376 208.512c26.208 14.784 59.872 22.208 93.504 22.208 33.664 0 67.328-7.392 93.536-22.208l369.376-208.512c28.256-15.936 43.808-38.304 43.808-62.944s-15.552-47.008-43.776-62.944zM984.48 665.728c-8.192-4.64-18.624-1.76-23.328 6.496-4.64 8.224-1.728 18.656 6.496 23.296 16.768 9.472 26.4 21.568 26.4 33.152s-9.632 23.68-26.4 33.184l-369.376 208.512c-41.536 23.456-111.808 23.488-153.408 0l-369.376-208.544c-16.768-9.472-26.368-21.568-26.368-33.184 0-11.584 9.6-23.68 26.368-33.152 8.224-4.64 11.136-15.072 6.496-23.296-4.672-8.224-15.136-11.168-23.328-6.496-28.192 15.968-43.744 38.304-43.744 62.976s15.52 47.008 43.776 62.944l369.376 208.512c26.208 14.784 59.872 22.208 93.504 22.208 33.664 0 67.328-7.392 93.536-22.208l369.376-208.512c28.256-15.968 43.808-38.304 43.808-62.944s-15.584-47.008-43.808-62.944z'></path></svg>",
          "action": {
            "type": "link",
            "target": "manager"
          }
        },
        {
          "title": "Fórum",
          "visible": false,
          "active": false,
          "icon": "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='768' height='768' viewBox='-40 -20 900 600'><path fill='#000' d='M544.5 384q0 13.5-9.75 22.5t-23.25 9h-319.5l-127.5 129v-448.5q0-13.5 9-22.5t22.5-9h415.5q13.5 0 23.25 9t9.75 22.5v288zM672 192q13.5 0 22.5 9t9 22.5v480l-127.5-127.5h-352.5q-13.5 0-22.5-9t-9-22.5v-64.5h415.5v-288h64.5z'></path></svg>",
          "action": {
            "type": "link",
            "target": "forum"
          }
        },
        {
          "title": "Arquivos",
          "visible": false,
          "active": false,
          "icon": "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='1024' height='1024' viewBox='0 -200 1024 1300'><path fill='#000' d='M32 416v-192.283c0-35.247 28.693-63.717 64.088-63.717h351.912l64 128h383.813c35.482 0 64.187 28.583 64.187 63.843v64.157h-928zM32 448v352.283c0 35.19 28.791 63.717 63.785 63.717h800.43c35.228 0 63.785-28.564 63.785-63.843v-352.157h-928z'></path></svg>",
          "action": {
            "type": "link",
            "target": "files"
          }
        },
        {
          "title": translation.courses.menu_help,
          "visible": true,
          "active": false,
          "icon": "<svg width='34' height='34' viewBox='-6 -12 46 46' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M15.3 26.5H18V23.8H15.3V26.5ZM17 0C14.7675 0 12.5569 0.439718 10.4944 1.29405C8.43185 2.14838 6.55778 3.40059 4.97918 4.97918C1.79107 8.1673 0 12.4913 0 17C0 21.5087 1.79107 25.8327 4.97918 29.0208C6.55778 30.5994 8.43185 31.8516 10.4944 32.706C12.5569 33.5603 14.7675 34 17 34C21.5087 34 25.8327 32.2089 29.0208 29.0208C32.2089 25.8327 34 21.5087 34 17C34 14.7675 33.5603 12.5569 32.706 10.4944C31.8516 8.43185 30.5994 6.55778 29.0208 4.97918C27.4422 3.40059 25.5682 2.14838 23.5056 1.29405C21.4431 0.439718 19.2325 0 17 0ZM17 31C9.503 31 3 24.497 3 17C3 9.503 9.503 3 17 3C24.497 3 31 9.503 31 17C31 24.497 24.497 31 17 31ZM17 7C15.1965 7 13.7752 7.51643 12.5 8.79167C11.2248 10.0669 11 11.7965 11 13.6H13.6C13.6 12.6983 13.9582 11.8335 14.5958 11.1958C15.2335 10.5582 16.0983 10.2 17 10.2C17.9017 10.2 18.7665 10.5582 19.4042 11.1958C20.0418 11.8335 20.4 12.6983 20.4 13.6C20.4 17 15.3 16.575 15.3 22.1H18C18 18.275 23.5 17.85 23.5 13.6C23.5 11.7965 22.7752 10.0669 21.5 8.79167C20.2248 7.51643 18.8035 7 17 7Z' fill='#4B618B'/></svg>",
          "action": {
            "type": "link",
            "target": "https://euconquisto.atlassian.net/servicedesk/customer/portals",
            "window": "_blank"
          }
        }
      ]

      const labelsReplacement = [];

      let hasCatalogMenu = false;
      var isAcademy = false;

      if (config && "config" in config) {
        const configData = config.config;

        if (configData && "users_group" in configData) {
          const {
            enabled = false,
          } = configData.users_group;

          hasCatalogMenu = enabled;
        }

        if (configData && "sidebar" in configData) {
          const {
            course_menu_label,
          } = configData.sidebar;

          if (course_menu_label) {
            labelsReplacement.push({
              label: course_menu_label,
              target: "Cursos",
            });
          }
        }

        if (configData && configData.common && configData.common.modality) {
          isAcademy = configData.common.modality === "academies";
        }
      }

      if (items.length > 0 && "activeMenu" in flow.data) {
        items = items.map(item => {
          item.active = item.title === flow.data.activeMenu;

          if (item.title === "Catálogo" && !hasCatalogMenu) {
            item.visible = false;
          }

          if (labelsReplacement.length > 0) {
            labelsReplacement.forEach(replacement => {
              if (item.title === replacement.target) {
                item.title = replacement.label;
              }
            });
          }

          return item;
        });
      }

      if (isAcademy) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].title === translation.courses.menu_courses || items[i].title === "Catálogo") {
            items[i].visible = false;
          };
          if (items[i].title === "Academia") {
            items[i].visible = true;
          }
        }
      }

      return items;
    },
    redirect_to_courses_if_has_no_catalog: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      let hasCatalogMenu = false;
      let isAcademy = false;

      if (config && "config" in config) {
        const configData = config.config;
        isAcademy = configData.common.modality === "academies";

        if (configData && "users_group" in configData) {
          const {
            enabled = false,
          } = configData.users_group;

          hasCatalogMenu = enabled;
        }
      }

      const isOnCatalog = window.location.href.includes("#/catalogo");

      if (isOnCatalog && !hasCatalogMenu) {
        if (isAcademy) {
          window.location.href = "#/academia";
        } else {
          window.location.href = "#/inicio";
        }
      }
    },
    get_courses_catalog: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      let rdp_course_catalog_subscribe = window.localStorage.getItem(window.location.origin + "RDP_COURSE_CATALOG_SUBSCRIBE");
      if (rdp_course_catalog_subscribe !== null) {
        window.localStorage.removeItem(rdp_course_catalog_subscribe);
      }

      const courses = [];

      let confirmButtonLabel = "Inscreva-se";

      if (config && "config" in config) {
        const configData = config.config;
        if (configData && "users_group" in configData) {
          const {
            subscription_button_label = false,
          } = configData.users_group;

          confirmButtonLabel = subscription_button_label;
        }
      }

      try {
        const response = await bridgeWrapper(`cms/v1.0/learning/courses/register?filter_only_to_register=true&filter_include_registers=true`);

        if (response && response.result && response.result.length > 0) {
          response.result.forEach((item) => {
            if (item.registers && item.registers.length > 0) {
              item.registers.forEach((register) => {
                          const course = {
                  metadata: register,
                  title: `${item.title} / ${register.name}`,
                  description: register.description,
                  image: item.thumb_url,
                            buttonText: confirmButtonLabel,
                            buttonDisabled: false,
                          };
                          courses.push(course);
              });
                }
          });
        } else {
          console.log('Nenhum retorno', response ? response.message : 'Nenhum dado retornado');
        }

      } catch (error) {
        console.error(error);
      }

      window.localStorage.setItem(window.location.origin + "RDP_COURSE_CATALOG_SUBSCRIBE", "true");

      return courses;
    },
    get_academies: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const coursesReq = await fetch(`${Sdk.Api.domain}/cms/v1.0/learning/courses`, {
        method: 'GET',
        headers: {
          "Project-Key": Sdk.Api.projectKey,
          "Api-Env": Sdk.Api.enviroment,
          "Authorization": `Bearer ${Sdk.Api.authorization.credential.accessToken}`,
          "Content-Type": "application/json"
        }
      });

      var coursesRes = await coursesReq.json();
      var courses = courses = coursesRes.result;

      for (var i = 0; i < courses.length; i++) {
        var treeRes = await fetch(`${Sdk.Api.domain}/cms/v1.0/learning/register/uid/${courses[i].register.uid}/nodes/tree`, {
          method: 'GET',
          headers: {
            "Project-Key": Sdk.Api.projectKey,
            "Api-Env": Sdk.Api.enviroment,
            "Authorization": `Bearer ${Sdk.Api.authorization.credential.accessToken}`,
            "Content-Type": "application/json"
          }
        });

        let status = await bridgeWrapper(`cms/v1.0/learning/register/uid/${courses[i].register.uid}/status`);
        var statusNodes = status.nodes;

        var tree;
        if (treeRes.ok) {
          tree = await treeRes.json();
        }

        for (var j = 0; j < tree.length; j++) {
          for (var k = 0; k < statusNodes.length; k++) {
            if (tree[j].uid === statusNodes[k].uid) {
              tree[j].progress = Number((statusNodes[k].activities.total_status_completed / statusNodes[k].activities.total_activities * 100).toFixed())
              tree[j].status = statusNodes[k];
            }
          }
        }
        courses[i].tree = tree;
      }

      return courses;
    },
    get_academies_v2: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      var requests = {
        "req": bridgeWrapper,
        "sdk": Sdk
      }

      return requests;
    },
    redirect_login_if_on_cordova: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      document.addEventListener('deviceready', () => {
        console.log("deviceready");
        if (window.cordova) {
          window.location.href = "#/mobile-login";
        }
      });
     //if (window.cordova || window.location.hostname === "localhost") {
      console.log(window.cordova);
      console.log("# # redirect_login_if_on_cordova");
      if (window.cordova) {
        window.location.href = "#/mobile-login";
      }
    },
    auto_login_on_cordova: async (params, bridgeWrapper, contextFinal, config, flow, appContext) => {
      const doLogin = async () => {
        // Mostrar tela de carregamento
        const loadingScreen = document.createElement('div');
        loadingScreen.id = 'cordova-loading-screen';
        loadingScreen.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        `;

        // Adicionar logo se disponível
        if (config?.config?.header?.logotype) {
          const logo = document.createElement('img');
          logo.src = config.config.header.logotype;
          logo.style.cssText = `
            max-width: 200px;
            max-height: 100px;
            margin-bottom: 20px;
          `;
          loadingScreen.appendChild(logo);
        }

        document.body.appendChild(loadingScreen);

        if (localStorage.getItem("rdp-app-credentials")) {
          const credentials = JSON.parse(localStorage.getItem("rdp-app-credentials"));
          
          try {
            // Configurar o projeto antes do login
            if (credentials.projectUid) {
              await Sdk.initializeFromProject(credentials.projectUid, "DirectRegister_1");
              Sdk.authorization.activeProjectUid = credentials.projectUid;
            }
            
            // Realizar o login sem delay
            await Sdk.Api.authorization.signinByLogin(credentials.login, credentials.password);
            
            // Configurar contexto após login bem-sucedido
            if (credentials.projectUid) {
              Sdk.authorization.setActiveProject({
                uid: credentials.projectUid
              });
            }
            
            // Remover tela de carregamento e redirecionar
            document.body.removeChild(loadingScreen);
            window.location.replace(window.location.origin + window.location.pathname + "#/catalogo");
            
          } catch (error) {
            console.error("Auto-login failed:", error);
            // Em caso de erro, remove tela de carregamento e mostra login
            document.body.removeChild(loadingScreen);
            window.location.href = "#/mobile-login";
          }
        } else {
          // Se não houver credenciais, remove tela de carregamento e mostra login
          document.body.removeChild(loadingScreen);
          window.location.href = "#/mobile-login";
        }
      }

      // Executar login quando o dispositivo estiver pronto
      if (document.readyState === "complete") {
        doLogin();
      } else {
        document.addEventListener('deviceready', doLogin);
        // Fallback se o evento deviceready não for disparado
        window.addEventListener('load', doLogin);
      }
    },
    get_download_listeners: async (params, bridgeWrapper) => {
      console.log("PARAMS", params);
      if (window.cordova) {
        return {
          "uid": params.uid,
          "download_package": function() {
            if (window.cordova) {
              Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${params.registerUid}/download`, null, 'GET')
            } else {
              console.log("DOWNLOAD COURSE", params.uid);
            };
          },
          "remove_package": function() {
            if (window.cordova) {
              Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${params.registerUid}/download`, null, 'DELETE')
            } else {
              console.log("REMOVE COURSE", params.uid);
            }
          },
          "get_download_progress": async function() {
            if (window.cordova) {
              console.log("Atualizando Progresso", params.uid);
              return Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${params.registerUid}/status`, null, 'GET')
            }
          },
        }
      } else {
        return null;
      }
    }
  }
}



// "element.review_tasks && element.review_tasks.length > 0 ? ([element.review_tasks[element.review_tasks.length - 1]].filter(p => p.status == 'Failed').map(p => (p.flow = element.review_flows.find(f => f.uid == p.review_flow_uid), { 'title': p.flow.title, 'description': p.flow.description, 'status': p.status, 'route': `/player/curso/${element.course.uid}/atividade/${p.target_uid}` }))) : []",
